var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('subHeader'),_c('div',{staticClass:"quiz"},[_c('iframe',{attrs:{"src":_vm.iframeSrc,"frameborder":"0","scrolling":"yes","width":"100%","height":"100%","id":"ngxFrame67c7fc45-b1e8-4e2f-93d8-7327c7e9803a","allowTransparency":"true"}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }